import { render, staticRenderFns } from "./PaymentAddressInput.vue?vue&type=template&id=ff89e590&scoped=true"
import script from "./PaymentAddressInput.vue?vue&type=script&lang=ts"
export * from "./PaymentAddressInput.vue?vue&type=script&lang=ts"
import style0 from "./PaymentAddressInput.vue?vue&type=style&index=0&id=ff89e590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff89e590",
  null
  
)

export default component.exports